import { AfterViewInit } from '@angular/core';
import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appEqualizer]'
})
export class EqualizerDirective implements AfterViewInit {

  element: ElementRef = null;
  elements: HTMLCollectionOf<Element> = null;
  oldBiggestHeight: number = 0;
  biggestHeight: number = 0;

  constructor(private el: ElementRef) {
    this.element = el;
    this.elements = document.getElementsByClassName(this.element.nativeElement.className);
  }

  ngAfterViewInit() {
    this.equalize(this.elements);
  }

  equalize = (elements: HTMLCollectionOf<Element>) => {
    this.setBiggestHeight(elements);
    this.element.nativeElement.style.height = `${this.biggestHeight}px`;
  }

  setBiggestHeight = (elements: HTMLCollectionOf<Element>) => {
    [].forEach.call(elements, (element: HTMLElement) => {
      if (element.offsetHeight > this.biggestHeight) {
        this.oldBiggestHeight = this.biggestHeight;
        this.biggestHeight = element.offsetHeight;
      }
    })
  };

}



// WEBPACK FOOTER //
// ./src/app/helper/directives/equalizer.directive.ts